import { Separator } from "@chakra-ui/react-v3";
import { ResourceAnalysis } from "../components/resource-analysis";
import { DocumentsSection } from "../components/side-panel-sections/documents-section";
import { EncounterNarrativeView } from "../components/side-panel-sections/encounter-narrative-view";
import { SidePanelLayout } from "../components/side-panel-sections/side-panel-layout";
import { EncounterRowData } from "../tables/encounter";

export type EncounterSidePanelContentProps = {
  data: EncounterRowData;
};

export function EncounterSidePanelContent({ data }: EncounterSidePanelContentProps) {
  const dateRange =
    data.startDate !== "-" && data.endDate !== "-"
      ? `${data.startDate} to ${data.endDate}`
      : data.startDate !== "-"
      ? data.startDate
      : data.endDate;

  return (
    <SidePanelLayout title="Encounter" subtitle={data.type} metadata={dateRange}>
      <ResourceAnalysis />

      <Separator borderColor="border" />

      <EncounterNarrativeView encounter={data.originalData} />

      <Separator borderColor="border" />

      <DocumentsSection resources={[data.originalData]} resourceType="Encounter" />
    </SidePanelLayout>
  );
}
